import React from 'react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  textColor?: string;
  linkColor?: string;
  variant?: 'light' | 'dark';
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ 
  items, 
  textColor = 'text-gray-500',
  linkColor = 'hover:text-emerald-600',
  variant = 'light'
}) => {
  const currentPageColor = variant === 'light' ? 'text-gray-900' : 'text-white';
  const defaultLinkColor = variant === 'light' ? linkColor : 'text-gray-300 hover:text-white';
  
  return (
    <div className="w-full">
      <nav aria-label="Breadcrumb" className="max-w-[1400px] mx-auto px-4 py-4">
        <ol className={`flex items-center space-x-2 text-sm ${variant === 'light' ? textColor : 'text-gray-400'}`}>
          <li>
            <a href="/" className={`${defaultLinkColor} hover:underline`}>
              Home
            </a>
          </li>
          {items.map((item, index) => (
            <React.Fragment key={item.label}>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </li>
              <li className="flex items-center">
                {item.href ? (
                  <a href={item.href} className={`${defaultLinkColor} hover:underline`}>
                    {item.label}
                  </a>
                ) : (
                  <span className={currentPageColor} aria-current="page">
                    {item.label}
                  </span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb; 